import React from "react";

const DriverIcon = ({ height, width, color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ?? 16}
      height={height ?? 16}
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill={color}
        d="M6.243 7.87c.375-.082.753-.146 1.133-.19a6.78 6.78 0 013 .31c.385.151.72.405.97.733.614.88 1.157 1.807 1.707 2.727.383.643.187 1.743-.457 2.09-.333.177-.813.073-1.226.077-.04 0-.093-.164-.117-.254-.36-1.43-1.177-2.176-2.623-2.41a.84.84 0 01-.304-.126c-.056-.034-.08-.117-.123-.177-.626-.897-1.263-1.793-1.96-2.78zM8.127 7.3a2.417 2.417 0 01-2.31-2.507 2.393 2.393 0 012.31-2.46 2.394 2.394 0 012.333 2.52A2.413 2.413 0 018.127 7.3zM7.833 10.91c-1.573.21-2.53 1-2.87 2.477a.433.433 0 01-.31.25c-.576.09-1.043 0-1.366-.614-.324-.613-.427-1.1-.034-1.69.534-.806 1-1.65 1.527-2.476.08-.138.174-.267.28-.387.467-.52.727-.503 1.117.06l1.656 2.38z"
      ></path>
      <path
        fill={color}
        d="M10.527 13.62H5.703a1.543 1.543 0 01.83-1.477 2.866 2.866 0 013-.14 1.71 1.71 0 01.994 1.617z"
      ></path>
    </svg>
  );
};

export default React.memo(DriverIcon);